import React from "react";

import { SearchComponent } from "@utils/search/@types/searchComponent";

import { ProductSortBy } from "@components/Search/SearchResults/StateComponents/Sort/sort.config";
import {
    Sort,
    SortConfiguration,
} from "@components/Search/SearchResults/StateComponents/Sort/sort.container";

const productSortByConfiguration: Array<SortConfiguration> = [
    {
        tkLabel: "search.filters.sort.default",
        value: ProductSortBy.DEFAULT,
        default: true,
    },
    {
        tkLabel: "search.filters.sort.price-asc",
        value: ProductSortBy.PRICE_ASC,
    },
    {
        tkLabel: "search.filters.sort.price-desc",
        value: ProductSortBy.PRICE_DESC,
    },
];

type ProductSortProps = {
    className?: string;
};

const ProductSort = ({ className }: ProductSortProps) => (
    <Sort
        className={className}
        component={SearchComponent.PRODUCT_SORT}
        configuration={productSortByConfiguration}
    />
);

export { ProductSort };
